import { GlobalOutlined, UploadOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import Loading from 'components/layout/Loading';
import React, { FC, useMemo, useState } from 'react';
import {
  default as H5AudioPlayer,
  default as ReacttH5AudioPlayer,
  RHAP_UI
} from 'react-h5-audio-player';
import { Brief, Translation } from 'store/types';
import { useStore } from 'store/zustandProvider';
import AudioPlayer from './AudioPlayer';
import BriefIcon from './BriefIcon';
import LanguagesPopover from './LanguagesPopover';
import ShareComponent from './ShareComponent';
import SwitchStatus from './SwitchStatus';

interface BriefAudioPlayerProps {
  brief: Brief;
  onChangedTranslation?: (translation: Translation) => void;
  translation?: Translation;
}
const BriefAudioPlayer: FC<BriefAudioPlayerProps> = ({
  brief,
  onChangedTranslation,
  translation
}) => {
  const audioPlayerRef = React.useRef<any>();
  const { ownChannel } = useStore();

  const currentTranslation = useMemo(() => {
    return translation || brief?.translations?.[0];
  }, [translation, brief?.translations]);




  const isBriefCoeditor = useMemo(() => {
    return brief?.channel?.rule > 1 || ownChannel
  }, [brief?.channel?.rule]);

  const audio = useMemo(() => {
    return currentTranslation.audio;
  }, [brief.translations, currentTranslation]);

  return (
    <React.Fragment>

      <div className="flexRow briefAudio">
        <AudioPlayer ref={audioPlayerRef} audio={audio} autoPlay={false} briefUUID={brief.uuid} />

        {/* {playerState} */}
        <div className="flexRow briefActions">
          <LanguagesPopover
            translation={currentTranslation}
            briefUUID={brief.uuid}
            onTranslatation={onChangedTranslation}
          />

          {isBriefCoeditor && <SwitchStatus brief={brief} />}

          {!isBriefCoeditor && <ShareComponent brief={brief} />}
        </div>
      </div>

    </React.Fragment>
  );
};

export default BriefAudioPlayer;
